
import React, { useMemo } from 'react'
import { useDrop } from 'react-dnd'

import { styled } from '@mui/material'
import { GridRow, GridRowProps } from '@mui/x-data-grid-premium'

import { GridTableDragItem, GridTableDragType } from '../models/GridTableDragType'
import { useDragDropGridContext } from './DragDropGridContext'

export type DroppableGridRowProps = GridRowProps & {
  //
}

export const DroppableGridRow: React.FC<DroppableGridRowProps> = (props) => {
  const { draggingRows, onGridRowsDrop } = useDragDropGridContext()
  const isDragging = useMemo(() => draggingRows.includes(props.row.id), [draggingRows, props.row.id])
  const isDroppable = props.row.isDroppable
  const dragType = props.row?.dragType || GridTableDragType.ROW
  const acceptDropTypes = props.row?.acceptDropTypes || [dragType]

  const [{ isOver }, dropRef] = useDrop({
    accept: acceptDropTypes,
    drop: (item: GridTableDragItem) => {
      if (isDroppable && onGridRowsDrop && !isDragging) {
        onGridRowsDrop(item.rows, props.row)
      }
    },
    collect: monitor => ({
      isOver: isDroppable && monitor.isOver(),
    }),
  }, [isDragging, isDroppable, dragType])

  return (
    <div ref={dropRef}>
      <StyledGridRow
        {...props}
        $isOver={isOver && onGridRowsDrop !== undefined}
        $isDragging={isDragging}
      />
    </div>
  )
}

const StyledGridRow = styled(GridRow, { shouldForwardProp: (prop) => prop !== '$isOver' && prop !== '$isDragging' }) <{ $isOver: boolean, $isDragging: boolean }>`
  position: relative;
  opacity: ${({ $isDragging }) => ($isDragging ? 0.5 : 1)};

  &::after {
    content: '';
    display: block;
    position: absolute;
    z-index: 4;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 2px;
    opacity: ${({ $isOver, $isDragging }) => ($isOver && !$isDragging ? 1 : 0)};
    background-color: ${({ theme }) => theme.palette.secondary.main};
  }
`
